// 🎯 Score de campagne concours /100 — DÉTERMINISTE (zéro IA, instantané).
// Chaque dimension = points + recommandation concrète si elle manque.
// Utilisé par le panneau de score du builder (avant publication).

export function scoreConcours(config) {
  const items = [];
  const add = (ok, points, label, fix, apply) => items.push({ ok, points: ok ? points : 0, max: points, label, fix, apply });

  const title = config.headline || '';
  const fieldsCount = 2 // e-mail + participation
    + (config.show_name ? 2 : 0)
    + (config.show_birthdate ? 1 : 0)
    + (config.show_phone ? 1 : 0)
    + (config.show_address ? 3 : 0);

  add(!!config.prize_image_url, 15, 'Photo du lot',
    'La photo réelle du lot est le 1er facteur de participation — ajoute-la (assistant ou champ « Photo du lot »).');
  add(!!(config.prize_value || '').trim(), 10, 'Valeur du lot affichée',
    'Précise la valeur (« Valeur : 100 CHF ») — un lot chiffré est 2× plus crédible.');
  add(title.length > 0 && title.length <= 60, 10, 'Titre court et percutant',
    `Ton titre fait ${title.length} caractères — vise 60 max, le lot d'abord.`);
  add(fieldsCount <= 6, 15, 'Formulaire léger',
    `${fieldsCount} champs demandés — chaque champ en plus fait perdre des participants. Repasse en modèle Relation ?`);
  add(!!config.reward_all_enabled, 15, 'Récompense pour tous',
    'Un petit avantage pour chaque participant (bon à code) transforme le concours en visites réelles.',
    (cfg) => ({ ...cfg, reward_all_enabled: true }));
  add(!!(config.rules || '').trim(), 10, 'Règlement présent',
    'Le règlement protège juridiquement — restaure celui d\'Appee si tu l\'as vidé.');
  add(!!config.consent_participation_text, 10, 'Consentements conformes',
    'Textes de consentement séparés absents — recrée la page depuis l\'assistant.');
  add(!!config.end_date, 10, 'Date de tirage définie',
    'Sans date de fin, pas d\'urgence ni de compte à rebours.');
  add((config.bullets || []).length >= 2, 5, 'Arguments de réassurance',
    'Garde 2-3 puces (« gratuit, sans engagement, tirage transparent »).');

  const score = items.reduce((a, i) => a + i.points, 0);
  const max = items.reduce((a, i) => a + i.max, 0);
  return { score: Math.round((score / max) * 100), items };
}
